import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { FacilityDetailsProvider } from 'contexts/FacilityDetailsContext'
import { FacilityConfigProvider } from 'contexts/FacilityConfigContext'

const PermissionViewPage = lazy(() => import('pages/AVPPermission/PermissionViewPage'))
const PermissionEditPage = lazy(() => import('pages/AVPPermission/PermissionEditPage'))

const BarrierRoutes = (
  <>
    <Route
      path="/admin/:project_id/permission"
      element={
        <FacilityConfigProvider slug="project_feature_config">
          <FacilityDetailsProvider>
            <PermissionViewPage />
          </FacilityDetailsProvider>
        </FacilityConfigProvider>
      }
    />
    <Route
      path="/admin/:project_id/permission/edit"
      element={
        <FacilityConfigProvider slug="project_feature_config">
          <FacilityDetailsProvider>
            <PermissionEditPage />
          </FacilityDetailsProvider>
        </FacilityConfigProvider>
      }
    />
  </>
)

export default BarrierRoutes
